export enum PaymentTabsEnum {
    CreditCard = 1,
    PayPal = 2,
    AliPay = 3,
    None = 4,
    PaypalDss = 5,
    ApplePay = 7,
}